import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "qa/";

export const filteredAgentApp = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}filteredagentapp`,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredAgentApp: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredApplicationStatus = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}filteredapplicationstatus`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredApplicationStatus: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredCampaign = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}filteredcampaign`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredCampaign: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredTaskGroup = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}filteredtaskgroup`,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredTaskGroup: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListAgent = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getlistagent`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListSPV = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getlistspv`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListSPV: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const QAForm = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}qaform`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API QAForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const QAViewTable = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}qaviewtable`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API QAViewTable: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const SaveQAForm = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}saveqaform`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API SaveQAForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
